import { View, Text } from "react-native";
import { Link, LinkText } from "ui/gluestack/link";
import KeyValueGrid from "ui/organisms/KeyValueGrid";
import { GridItem } from "ui/types/GridItem";

interface Props {
  items: GridItem[];
  title?: string;
  href?: string;
}

export function LogSection({ items, title, href }: Props) {
  return (
    <View className="mb-10 last:mb-0">
      <Text className="text-base text-primary-400 ">{title}</Text>
      {items.length === 0 && href ? (
        <Text>
          No reports listed. Navigate to
          <Link href={href}>
            <LinkText className="text-primary-500 underline text-sm mx-1 font-medium">
              Reports
            </LinkText>
          </Link>
          to create your first report.
        </Text>
      ) : (
        <KeyValueGrid items={items} />
      )}
    </View>
  );
}
